import { useRef, useState } from 'react';

export function useGoalActions(goalId, onUpdated) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const tRef = useRef(null);

  const flash = (text) => {
    setMsg(text);
    window.clearTimeout(tRef.current);
    tRef.current = window.setTimeout(() => setMsg(''), 1200);
  };

  async function refetchMe() {
    const res = await fetch('/api/goals/summary');
    if (!res.ok) return null;

    const all = await res.json();
    const updated = Array.isArray(all) ? all.find((x) => x.id === goalId) : null;

    if (updated) onUpdated?.(updated);
    else onUpdated?.({ id: goalId, removed: true });

    return updated;
  }

  async function post(url, body = {}) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      let err = 'Ошибка';
      try {
        const j = await res.json();
        if (j?.error) err = j.error;
      } catch {}
      throw new Error(err);
    }

    return true;
  }

  return {
    busy,
    setBusy,
    msg,
    flash,
    refetchMe,
    post,
  };
}